// extracted by mini-css-extract-plugin
export default {"container":"DyQZna","button":"QvPRFD","icon":"_RaP0v","text":"RSniAb","title":"whvreu","info":"thm3HI"};